import {Dialog, Grid, AppBar, Typography, Toolbar, IconButton, FormControl} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {monthNames, getCityName} from './Trans.js';
import {dateStr} from './Util.js';

const PtsDialog = observer((props) => {
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const n = gStorage.conn.pts_notification;

	function ptsGetCityName(id) {
		return getCityName(gStorage.lists.citylist.list.find(option => option.id === id), gStorage.conn.user);
	}

	if (!n || !n.flags)
		return null;

	return (
        	<Dialog onClose={() => handleClose(false)} aria-labelledby="pts-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('pts.new_pts')}</Typography>
						<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>

				<Grid size={{xs: 12}} align={'center'} style={{width:300}}>
					<FormControl variant="outlined" size="small" style={{width:300}} >
						<div>&nbsp;</div>

						{(n.flags & 0x02) ?
						<div>
							{t('pts.new_month_pt')} <b>{t(monthNames[n.month - 1])}</b>
							<div>&nbsp;</div>
						</div> : null}

						{(n.flags & 0x01) ?
						<div>
							{t('pts.new_city_pt')} <b>{ptsGetCityName(n.city)}</b>
							<div>&nbsp;</div>
						</div> : null}

						{(n.flags & 0x04) ?
						<div>
							{t('pts.new_date_pt')} <b>{dateStr(n.date)}</b>
						</div> : null}


						<div>&nbsp;</div>
					</FormControl>
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default PtsDialog;
